import React from 'react'
import styled from 'styled-components'

const CenterContent = styled.div`
  max-width: ${props => props.theme.containerWidths.small};
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const DemiTrainingPage = props => (
  <CenterContent className="section">
    <p className="headline--intro">
      For information and training on Demi Colour,{' '}
      <a
        href="https://www.demicolour.com/en/office/resources/training"
        target="_blank"
        rel="noopener noreferrer"
      >
        click here
      </a>
      .
    </p>
  </CenterContent>
)

export default DemiTrainingPage
